import { h } from "preact";
import { Link } from "preact-router/match";

import style from "./style";
import { localPath } from "../../../path";

/*
this does not work well: why?
<Link href={localPath + path}></Link>
*/

const ResultListItem = ({ path, children }) => (
  <li>
    <a href={path} class={style["result-list-item"]}>
      {children}
    </a>
  </li>
);

export default ResultListItem;
